module.exports = __webpack_public_path__ + "static/OP12-aa7fbcf1bf2fe708f24ee1cab11b9dda.png";